var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 100,
    viewBox: "0 0 110 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2139_18774",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 111,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H110.23V100H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2139_18774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8884 19.8893C42.5028 17.9848 40.4853 16.4359 37.9405 15.5957C31.635 13.5137 24.6634 16.4631 22.3683 22.1832L19.252 29.951C17.1199 35.2652 19.7792 41.0961 25.2229 43.567L29.929 45.1211",
    stroke: "#F04336",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3438 19.8893C67.7294 17.9848 69.7469 16.4359 72.2917 15.5957C78.5972 13.5137 85.5688 16.4631 87.8639 22.1832L90.9802 29.951C93.1123 35.2652 90.453 41.0961 85.0093 43.567L80.3032 45.1211",
    stroke: "#F04336",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7274 51.8682C63.7274 55.1041 59.8717 59.6807 55.1157 59.6807C50.3596 59.6807 46.5039 55.1041 46.5039 51.8682C46.5039 48.632 50.3596 47.9619 55.1157 47.9619C59.8717 47.9619 63.7274 48.632 63.7274 51.8682Z",
    stroke: "#F04336",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1162 59.6807V67.4932",
    stroke: "#F04336",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.498 37.9424L63.7275 35.9893L66.9569 37.9424",
    stroke: "#F04336",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7332 37.9424L46.5038 35.9893L43.2744 37.9424",
    stroke: "#F04336",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5749 91.3867H48.6572V79.668H61.5749V91.3867Z",
    stroke: "#F04336",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5742 91.3867L72.5663 96.3726C75.4292 97.6712 78.7977 95.7826 78.7977 92.8789V78.1759C78.7977 75.272 75.4292 73.3834 72.5663 74.682L61.5742 79.6679V91.3867Z",
    stroke: "#F04336",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6571 91.3867L37.6651 96.3726C34.8021 97.6712 31.4336 95.7826 31.4336 92.8789V78.1759C31.4336 75.272 34.8021 73.3834 37.6651 74.682L48.6571 79.6679V91.3867Z",
    stroke: "#F04336",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23047 77.3438H16.1481",
    stroke: "#F04336",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68848 83.2031V71.4844",
    stroke: "#F04336",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002 91.2109H94.084",
    stroke: "#F04336",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.543 85.3516V97.0703",
    stroke: "#F04336",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002 8.78906H94.084",
    stroke: "#F04336",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.543 2.92969V14.6484",
    stroke: "#F04336",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2575 74.6133C81.1022 70.902 84.1801 65.3521 84.1801 59.1492C84.1801 57.0258 83.8115 54.9152 83.0881 52.8957L74.8443 29.884C72.0666 22.1307 64.102 16.8816 55.1154 16.8816C46.1291 16.8816 38.1645 22.1307 35.3868 29.884L27.143 52.8957C26.4194 54.9152 26.0508 57.0258 26.0508 59.1492C26.0508 65.3521 29.1288 70.902 33.9736 74.6133",
    stroke: "#F04336",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8426 2.92969C11.8426 4.54766 10.3967 5.85938 8.6132 5.85938C6.8297 5.85938 5.38379 4.54766 5.38379 2.92969C5.38379 1.31172 6.8297 0 8.6132 0C10.3967 0 11.8426 1.31172 11.8426 2.92969Z",
    fill: "#F04336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.064 58.7891C105.064 60.407 103.618 61.7188 101.835 61.7188C100.051 61.7188 98.6055 60.407 98.6055 58.7891C98.6055 57.1711 100.051 55.8594 101.835 55.8594C103.618 55.8594 105.064 57.1711 105.064 58.7891Z",
    fill: "#F04336"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.bef5f229688921f0ca8a7b74e59ab640.svg";
export { ForwardRef as ReactComponent };